import DOMPurify from 'isomorphic-dompurify';

/**
 * Sanitizes doctor-authored rich text (biography) before it touches
 * dangerouslySetInnerHTML. Isomorphic: runs in the browser and during SSR —
 * the payload must not survive either render path.
 *
 * Server storage is also allowlist-sanitized now, but existing rows (and any
 * writer outside the doctors service) still carry raw HTML, so the render side
 * keeps its own guard. DOMPurify's default profile keeps the legit rich text
 * the panel editor produces and strips handlers, javascript:/data: URLs and
 * script-context tags.
 */
export const sanitizeRichText = (html: string | null | undefined): string =>
  DOMPurify.sanitize(html ?? '', { USE_PROFILES: { html: true } });
